import type { ExecutionProgressHydration } from '../executionOperations/types';
import type { OperationalTimelineItem } from '../operationalCockpit/types';
import type { RouteOperationalRecovery } from './types';

const SEVERITY_KIND: Record<string, OperationalTimelineItem['kind']> = {
  recovery: 'recovery',
  execution: 'system',
  incident: 'incident',
  attention: 'system',
  coordination: 'system',
  mutation: 'system'
};

/** Prefer authoritative backend timeline; fallback to client merge. */
export function buildUnifiedOperationalTimeline(params: {
  hydration: ExecutionProgressHydration;
  recovery: RouteOperationalRecovery | null;
  clientTimeline: OperationalTimelineItem[];
}): OperationalTimelineItem[] {
  const backend = params.hydration.operationalTimeline?.entries ?? [];
  if (backend.length) {
    return backend.map((e) => ({
      key: e.key,
      at: e.timestamp,
      label: e.title,
      kind: SEVERITY_KIND[e.type] ?? 'system',
      completed: e.severity === 'info' && e.type === 'recovery'
    }));
  }

  if (params.recovery?.recoveryTimeline.length) {
    const recoveryItems: OperationalTimelineItem[] = params.recovery.recoveryTimeline.map((r) => ({
      key: r.key,
      at: null,
      label: r.label,
      kind: 'recovery',
      completed: false
    }));
    return [...recoveryItems, ...params.clientTimeline].slice(0, 24);
  }

  return params.clientTimeline;
}
